import { Done, Edit, ContentCopy, RateReview, AutoStories } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { FieldAiConfigView } from "generated/graphql";

interface AiFieldConfigPreviewProps {
  aiFieldConfig: FieldAiConfigView;
}

interface AiFieldConfigValueProps {
  title: string;
  value: string;
}

const AiFieldConfigValue = (props: AiFieldConfigValueProps) => {
  const { title, value } = props;
  return (
    <div className="flex flex-col">
      <p className="text-xs font-bold">{title}</p>
      <p className="text-xs">{value}</p>
    </div>
  );
};

export const AiFieldPreview = (props: AiFieldConfigPreviewProps) => {
  const { aiFieldConfig } = props;
  return (
    <div className="w-full">
      <div className="flex flex-col gap-2 bg-gray-50 rounded p-2 mt-2">
        <div className="flex w-full gap-2">
          {aiFieldConfig.useReviewConfig && <Chip label="Use Review Config" size="small" icon={<RateReview />} />}
          {aiFieldConfig.lensHits && <Chip label="Lens Hits" size="small" icon={<Done />} />}
          {aiFieldConfig.maxContiguousPages && (
            <Chip
              label={`Max Contiguous Pages: ${aiFieldConfig.maxContiguousPages}`}
              size="small"
              icon={<AutoStories />}
            />
          )}
          {aiFieldConfig.fillNotes && <Chip label="Fill Notes" size="small" icon={<Edit />} />}
          {aiFieldConfig.multiResponse && <Chip label="Multi Response" size="small" icon={<ContentCopy />} />}
        </div>
        {aiFieldConfig.alternateName && (
          <AiFieldConfigValue title="Alternate Name" value={aiFieldConfig.alternateName ?? "None"} />
        )}
        {aiFieldConfig.alternatePrompt && (
          <AiFieldConfigValue title="Alternate Prompt" value={aiFieldConfig.alternatePrompt ?? "None"} />
        )}
      </div>
    </div>
  );
};
